import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f9068ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-credit" }
const _hoisted_2 = { class: "form-credit" }
const _hoisted_3 = { class: "creditLabel" }
const _hoisted_4 = { class: "radio-group" }
const _hoisted_5 = { class: "creditLabel" }
const _hoisted_6 = { class: "radio-group" }
const _hoisted_7 = { class: "input-wrapper" }
const _hoisted_8 = { class: "creditLabel" }
const _hoisted_9 = { class: "btn-next" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_FormTextInput = _resolveComponent("FormTextInput")!
  const _component_InputError = _resolveComponent("InputError")!
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!

  return (_openBlock(), _createBlock(_Transition, { name: "show-user-credit" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.creditData.text.titleLimits), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditData.text
                            .creditLimits, (creditLimit, id) => {
              return (_openBlock(), _createBlock(_component_RadioInput, {
                key: id,
                id: creditLimit.id.toString(),
                name: creditLimit.name,
                label: creditLimit.label,
                value: _ctx.limit,
                isChecked: creditLimit.id == _ctx.limit ? true : false,
                onRadioClicked: ($event: any) => (_ctx.handleInput(creditLimit.id, null))
              }, null, 8, ["id", "name", "label", "value", "isChecked", "onRadioClicked"]))
            }), 128))
          ]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.creditData.text.titleInstallments), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditData.text
                            .creditInstallments, (creditInstallment, id) => {
              return (_openBlock(), _createBlock(_component_RadioInput, {
                key: id,
                id: creditInstallment.id.toString(),
                name: creditInstallment.name,
                label: creditInstallment.label,
                value: _ctx.installment,
                isChecked: 
                            creditInstallment.id == _ctx.installment ? true : false
                        ,
                onRadioClicked: ($event: any) => (_ctx.handleInput(null, creditInstallment.id))
              }, null, 8, ["id", "name", "label", "value", "isChecked", "onRadioClicked"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.creditData.text.titleMotivo), 1),
            _createVNode(_component_MultiSelect, {
              options: _ctx.creditData.text.listReasons,
              modelValue: _ctx.reason,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason) = $event))
            }, null, 8, ["options", "modelValue"]),
            (_ctx.reason === _ctx.others)
              ? (_openBlock(), _createBlock(_component_FormTextInput, {
                  key: 0,
                  modelValue: _ctx.reasonOthers,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reasonOthers) = $event)),
                  placeholder: "Motivo",
                  name: "Motivo"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_InputError, {
                msg: _ctx.creditData.text.errors
              }, null, 8, ["msg"])
            ], 512), [
              [_vShow, _ctx.isInvalid]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ButtonDefault, {
              id: "btn-next-step-buttons",
              msg: "Continuar",
              onButtonClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextStepClicked()))
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}